import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';

const initialState = {
    data: [],
};

export const fetchStat = createAsyncThunk(
    'masters/fetchStat',
    async (query) => {
        try {
            const response = await myAxios.get(`/stats`);
            return { success: true, data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

const statSlice = createSlice({
    name: 'stat',
    initialState,
    reducers: {
        clearStatData: state => {
            state.data = [];
        },
        setStatData: (state, action) => {
            state.data = action.payload;
        },
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStat.fulfilled, (state, action) => {
                state.data = action.payload;  
            })
            .addCase(fetchStat.rejected, (state, action) => {
                console.log("Failed to fetch stat data:", action.payload);
            });
    },
});

export const statReducer = statSlice.reducer;
export const { clearStatData, setStatData } = statSlice.actions;

export const selectStatData = (state) => state.stat.data;
